import { useUndoRegister, useUndoRedoActions } from "Helpers";
import { FC, useEffect, useState } from "react";
import styled from "styled-components";
import { Option, useZakeke } from "zakeke-configurator-react";
import useStore from 'Store';
import noImage from '../../assets/images/no_image.png';
import Tooltip from "./tooltip";

const OptionContainer = styled.div<{ optionShape: number, selected: boolean }>`
    display:flex;
    flex-flow:column;
    justify-content:center;
    align-items:center;
    cursor:pointer;
    align-self: center;
    justify-self: center;
    position:relative;
    padding: 10px 0px;
    user-select: none;
    width:100%;

    &:hover {
        background-color: #f5f6f7;
    }
    
    ${props => props.selected && `
        background-color: #f5f6f7;
    `}
`;

const OptionIconContainerStyled = styled.div<{ optionShape?: number }>`
   overflow: hidden;
   width: 100%;
   aspect-ratio: 1;
   padding: 10px;
`;

const OptionIconContainer: FC<{
    children?: React.ReactNode
}> = ({ children }) => {
    return <OptionIconContainerStyled>{children}</OptionIconContainerStyled>;
}

const OptionIcon = styled.img<{ optionShape?: boolean }>`
    object-fit: contain;
    width: 100%;
    height: 100%;
    ${props => props.optionShape && `
    border-radius: 100%;
    object-fit: cover;
    `};
`;

const OptionName = styled.span`
    font-size:12px;
    margin-top: 10px;
    text-align:center;
    overflow:hidden;

    @media (max-width: 1025px) {
        font-size:10px;
        margin-top: 2px;
        text-align:center;
    }

    @media (max-width: 768px) {
        font-size:10px;
        text-align:center;
    }
`;

const OptionItem: FC<{ selectedOptionId: number, option: Option }> = ({ selectedOptionId, option }) => {

    const { selectOption, setCamera } = useZakeke();
    const { setPreviousCustomizeOptionId } = useStore();

    const undoRegistering = useUndoRegister();
    const undoRedoActions = useUndoRedoActions();

    const handleOptionSelection = (option: Option) => {
        const undo = undoRegistering.startRegistering();
        undoRedoActions.eraseRedoStack();
        undoRedoActions.fillUndoStack({ type: "option", id: selectedOptionId, direction: "undo" });
        undoRedoActions.fillUndoStack({ type: "option", id: option.id, direction: "redo" });
        setCamera(option.attribute.cameraLocationId!);
        selectOption(option.id);
        undoRegistering.endRegistering(undo);
    }

    let content = <OptionContainer

        selected={option.selected}
        optionShape={option.attribute.optionShapeType}
        onClick={() => handleOptionSelection(option)}>

        <OptionIconContainer>
            {option.description && option.description.length !== 0 &&
                <Tooltip key={"tooltip" + option.guid} optionDescription={option.description} />
            }
            {option.imageUrl !== ""
                ? <OptionIcon src={option.imageUrl!} optionShape={option.attribute.optionShapeType === 2} />
                : <OptionIcon src={noImage} optionShape={option.attribute.optionShapeType === 2} />
            }
        </OptionIconContainer>

        {!option.attribute.hideOptionsLabel && <OptionName >{option.name}</OptionName>}
    </OptionContainer>;

    return content;
}

export default OptionItem;